import { useState } from 'react';
import { RefreshCw } from 'lucide-react';
import { Button } from '@produzionejb/ui';
import { useVersionCheck } from '../lib/use-version-check';

/**
 * Banner non invadente mostrato quando è disponibile un nuovo deploy della SPA.
 * L'utente clicca "Aggiorna" e l'app si ricarica sulla versione nuova senza
 * dover fare un hard refresh. Finché non si clicca, l'app continua a funzionare
 * normalmente: nessuna interruzione del lavoro in corso.
 */
export function UpdateBanner() {
  const { updateAvailable, applyUpdate } = useVersionCheck();
  const [updating, setUpdating] = useState(false);

  if (!updateAvailable) return null;

  return (
    <div
      role="status"
      aria-live="polite"
      className="fixed bottom-4 left-1/2 z-[1000] flex max-w-[calc(100vw-2rem)] -translate-x-1/2 items-center gap-3 rounded-xl border border-slate-200 bg-white px-4 py-3 shadow-lg"
    >
      <RefreshCw className="w-5 h-5 shrink-0 text-brand-700" />
      <span className="text-sm text-slate-700">
        È disponibile una nuova versione di produzioneJB.
      </span>
      <Button
        type="button"
        size="sm"
        variant="primary"
        disabled={updating}
        onClick={() => {
          setUpdating(true);
          void applyUpdate();
        }}
      >
        {updating ? 'Aggiorno…' : 'Aggiorna'}
      </Button>
    </div>
  );
}
